module.exports = __webpack_public_path__ + "static/media/s98ga01.92895fcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/s98ga01.jpg
// module id = 270
// module chunks = 0